import { combineReducers } from "redux";
import { SET_DONATION, SET_CHANGED_OPT_INS, ACCOUNT_CREATE_SUCCESS, TOGGLE_ACCOUNT_CREATION, CLEAR_ERROR, CART_UPDATE_FAILED, UPDATE_CART_STATE, INIT } from "./actions.js";
import { CheckoutState } from "./state.js";
import paymentReducer from "./StepPayment/StepPayment/reducer.js";
import shippingMethodsReducer from "./StepShipping/modules/ShippingMethods/state/StepShipping/modules/ShippingMethods/state/reducer.js";
import shippingReducer from "./StepShipping/StepShipping/reducer.js";
import { CartState } from "./models/cart/models/cart/cart-state.js";
const initialRootState = {
  state: CheckoutState.Uninitialized
};
function checkoutReducer(state = initialRootState, action) {
  switch (action.type) {
    case INIT:
      return {
        state: CheckoutState.Initialized,
        cartState: CartState.InProgress
      };
    case UPDATE_CART_STATE:
      return {
        ...state,
        ...action.payload
      };
    case CLEAR_ERROR:
      return {
        ...state,
        state: CheckoutState.Initialized
      };
    default:
      return state;
  }
}
function errorReducer(state = null, action) {
  switch (action.type) {
    case CART_UPDATE_FAILED:
      return {
        ...state,
        ...action.error
      };
    case CLEAR_ERROR:
      return null;
    default:
      return state;
  }
}
function myAccountReducer(state = null, action) {
  switch (action.type) {
    case TOGGLE_ACCOUNT_CREATION:
      const { shouldCreateAccount } = action.payload;
      return {
        ...state,
        shouldCreateAccount
      };
    case ACCOUNT_CREATE_SUCCESS:
      const { id } = action.payload;
      return {
        ...state,
        newUserId: id
      };
    case SET_CHANGED_OPT_INS:
      return {
        ...state,
        changedOptIns: action.payload
      };
    default:
      return state;
  }
}
function donationReducer(state = [], action) {
  switch (action.type) {
    case SET_DONATION:
      const payload = action.payload;
      const updatedState = state.filter((item) => item.key !== payload.key);
      return [...updatedState, payload];
    default:
      return state;
  }
}
const reducer = combineReducers({
  root: checkoutReducer,
  shippingMethods: shippingMethodsReducer,
  shipping: shippingReducer,
  payment: paymentReducer,
  error: errorReducer,
  myAccount: myAccountReducer,
  donations: donationReducer
});
export {
  checkoutReducer,
  reducer as default,
  donationReducer,
  errorReducer,
  initialRootState,
  myAccountReducer
};
//# sourceMappingURL=reducer.js.map
